<template lang="pug">
  .reidejkopay
    .image
      img(src='../src/assets/rei-meta.jpg')
    .title 使用街口支付app，掃描QRcode
    .devider
    a.button(href='https://www.jkopay.com/transfer?j=Transfer:900433031') 打開街口，一鍵抖內
    .statement 註：請下載街口app, 並完成銀行綁定及實名驗證才能使用轉帳功能。
</template>

<script>
import HelloWorld from './components/HelloWorld.vue'
export default {
  name: 'Rei的Jkopay',
  components: {
    HelloWorld,
  }
}
</script>

<style lang='scss'>
body {
  background-color: #c9191d;
  margin: 0;
  font-family: "SF Pro TC","SF Pro Display","SF Pro Icons","PingFang TC","Helvetica Neue","Helvetica","Arial",sans-serif;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
.reidejkopay {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .title {
    color: #fff;
    font-size: 14px;
    // font-weight: 300;
  }
  .image {
    width: 90%;
    max-width: 400px;
    img {
      width: 100%;
      border-radius: 10px;
    }
  }
  .devider {
    height: 1px;
    width: 80%;
    background-color: rgba(0 , 0 , 0 , 0.1);
    margin: 3rem auto;
    max-width: 600px;
  }
  .button {
    padding: 1rem 2rem;
    border-radius: 8px;
    text-decoration: none;
    border: 1px solid #fff;
    color: #fff;
    margin-bottom: 2rem;
    display: none;
    @media only screen and (max-width: 600px) {
      display: block;
    }
  }
  .statement {
    // color: rgba(0 , 0 , 0 , 0.5);
    color: #fff;
    width: 80%;
    margin: 0 auto;
    font-size: 12px;
    font-weight: 300;
    max-width: 600px;
    // text-shadow: 0px 1px 0px rgba(255,255,255,.3), 0px -1px 0px rgba(0,0,0,.7);
  }
}
</style>
